<div class="grid">
  <div class="col-12 col-12 md:col-12">
    <p-accordion
      id="accordion"
      [multiple]="false"
      (onOpen)="abrirAcordeon($event.index)"
    >
      <p-accordionTab
        header="{{ titulo }}"
        [selected]="tabSeleccionado === 'DATGEN'"
      >
        <app-flujo-venta-tab-view
          [tabView]="tabView"
          [listaSecuencias]="listaSecuencias"
          [listaVinculaciones]="listaVinculaciones"
          [listaTiposPersonas]="listaTiposPersonas"
          [lisPasos]="lisPasos"
          [secFija]="false"
          [showControlesTable]="false"
          [HabilitarindicadorVinculacionPorPerfil]="true"
        >
        </app-flujo-venta-tab-view>
      </p-accordionTab>

      <!-- TAB Restricciones Perfil por Vinculación -->
      <p-accordionTab
        header="{{
          'FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_FLUJOVENTARESTRICCIONESPERFILXVINCULACION'
            | translate
        }}"
        [selected]="tabSeleccionado === 'RESPERXVIN'"
        [disabled]="!tabView.flujoVenta?.idFlujoVentaPaso"
        *ngIf="tabView.flujoVenta?.indicadorVinculacionPerfil"
      >
      <app-fv-restricciones-perfil-x-vinculacion [tabView]="tabView"></app-fv-restricciones-perfil-x-vinculacion>
      </p-accordionTab>


      <!-- TAB Tabla politicas -->
      <p-accordionTab
        header="{{
          'FLUJOVENTASPOLITICASCONFIGURADAS.LBL_POLITICASCONFIGURADAS'
            | translate
        }}"
        [selected]="tabSeleccionado === 'POLICONFIG'"
      >
      <app-flujo-venta-politicas-configuradas [tabView]="tabView"></app-flujo-venta-politicas-configuradas>
      </p-accordionTab>

    </p-accordion>
  </div>
</div>
